
const columnWidth = "auto";

export const columnsConfig = [
  {
    dataField: "PokerNetwork",
    dataType: "string",
    caption: "main.dataTable.poker_network",
    name: "Poker network",
    groupIndex: 0,
    autoExpandGroup: true,
    width: columnWidth,
    translate: true,
  },
  {
    dataField: "BigBlind",
    dataType: "number",
    caption: "main.dataTable.bbChips",
    name: "Big Blind (chips)",
    groupIndex: 1,
    autoExpandGroup: false,
    width: columnWidth,
    translate: true,
  },
  {
    dataField: "GameType",
    dataType: "string",
    caption: "main.dataTable.game_type",
    name: "Game type",
    width: columnWidth,
    translate: true,
  },
  // {
  //   dataField: "NormalLimit",
  //   dataType: "string",
  //   visible: false,
  //   caption: "Normal limit",
  //   name: "Normal limit",
  //   width: columnWidth,
  //   translate: false,
  // },
  {
    dataField: "UserID",
    dataType: "string",
    visible: false,
    caption: "main.dataTable.login",
    name: "Login",
    width: columnWidth,
    translate: true,
  },
  {
    dataField: "PlayerID",
    dataType: "string",
    visible: false,
    caption: "main.dataTable.PID",
    name: "PID",
    width: columnWidth,
    translate: true,
  },
  // {
  //   dataField: "Room",
  //   dataType: "number",
  //   visible: false,
  //   caption: "main.dataTable.room",
  //   name: "Room",
  //   width: columnWidth,
  //   translate: true,
  // },
  {
    dataField: "ClubID",
    dataType: "string",
    visible: false,
    caption: "main.dataTable.club",
    name: "Club",
    width: columnWidth,
    translate: true,
  },
  {
    dataField: "LeagueID",
    dataType: "string",
    visible: false,
    caption: "main.dataTable.leagueID",
    name: "League ID",
    width: columnWidth,
    translate: true,
  },
  {
    dataField: "SuperLeagueID",
    dataType: "string",
    visible: false,
    caption: "main.dataTable.superleagueID",
    name: "SuperLeague ID",
    width: columnWidth,
    translate: true,
  },
  {
    dataField: "Date",
    dataType: "date",
    format: "dd/MM/yyyy",
    visible: false,
    caption: "main.dataTable.date",
    name: "Date",
    translate: true,
  },
  {
    dataField: "Hands",
    dataType: "number",
    caption: "main.dataTable.hands",
    name: "Hands",
    translate: true,
  },
  {
    dataField: "NetWinUsd",
    dataType: "number",
    caption: "Net win, $",
    name: "Net win, $",
    translate: false,
  },
  {
    dataField: "AllinEVUsd",
    dataType: "number",
    caption: "all-in EV, $",
    name: "all-in EV, $",
    translate: false,
  },
  {
    dataField: "NetWin",
    dataType: "number",
    visible: false,
    caption: "main.dataTable.netWinChips",
    name: "Net win (chips)",
    translate: true,
  },
  {
    dataField: "AllinEV",
    dataType: "number",
    visible: false,
    caption: "main.dataTable.allInChips",
    name: "all-in EV (chips)",
    translate: true,
  },
  {
    dataField: "Fuel",
    dataType: "number",
    caption: "main.dataTable.fuel",
    name: "Fuel",
    translate: true,
  },
  {
    dataField: "NetWinrate",
    dataType: "number",
    caption: "bb/100",
    name: "bb/100",
    translate: false,
  },
  {
    dataField: "AllinEVWinrate",
    dataType: "number",
    caption: "EV bb/100",
    name: "EV bb/100",
    translate: false,
  },
  {
    dataField: "HandsHU",
    dataType: "number",
    caption: "main.dataTable.HUHands",
    name: "HU hands",
    translate: true,
  },
  {
    dataField: "HUPercent",
    dataType: "number",
    caption: "%HU",
    name: "%HU",
    customizeText: (cellInfo) => cellInfo.value + " %",
    translate: false,
  },
  {
    dataField: "HandsOperatorErrors",
    dataType: "number",
    caption: "main.dataTable.errorsOperator",
    name: "Errors operator",
    translate: true,
  },
  {
    dataField: "Error.percent",
    dataType: "number",
    caption: "main.dataTable.error",
    name: "Error",
    customizeText: (cellInfo) => cellInfo.value + " %",
    translate: true,
  },
  {
    dataField: "redBlackTables",
    dataType: "number",
    caption: "main.dataTable.R/BTables",
    name: "Red/Black tables",
    translate: true,
  },
  {
    dataField: "redBlackTablesPercent",
    dataType: "number",
    caption: "main.dataTable.R/BTablesPercent",
    name: "Red/Black tables percent",
    customizeText: (cellInfo) => cellInfo.value + " %",
    translate: true,
  },
];
